import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";
import { useWindowWidth } from "../../hooks/useWindowWidth";

const Chart = ({ displayedNutrient }) => {
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});
  const demo = useSelector((state) => state.demoReducer.demo);
  const intake_history = useSelector((state) =>
    demo ? state.demoReducer.intake_history_demo : state.nutritionReducer.intake_history
  );
  const windowWidth = useWindowWidth();

  useEffect(() => {
    const caloriesData = getNutrientDataSet("Calories", getMatchingDatesData("calories"));
    const fatData = getNutrientDataSet("Fat", getMatchingDatesData("fat"));
    const proteinData = getNutrientDataSet("Protein", getMatchingDatesData("protein"));
    const carbsData = getNutrientDataSet("Carbs", getMatchingDatesData("carbs"));

    const dataSets = [caloriesData, fatData, proteinData, carbsData];
    let displayedDataSet = dataSets[0];

    if (displayedNutrient === "calories") {
      displayedDataSet = dataSets[0];
    } else if (displayedNutrient === "fat") {
      displayedDataSet = dataSets[1];
    } else if (displayedNutrient === "protein") {
      displayedDataSet = dataSets[2];
    } else if (displayedNutrient === "carbs") {
      displayedDataSet = dataSets[3];
    }

    // Setting data and options
    setData({
      labels: displayedDates,
      datasets: displayedDataSet,
    });
    setOptions({
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              fontSize: windowWidth <= 800 ? 9 : 12,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              fontSize: windowWidth <= 800 ? 9 : 12,
            },
          },
        ],
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          fontSize: windowWidth <= 1000 ? 11 : 13,
          boxWidth: windowWidth <= 1000 ? 25 : 40,
        },
      },
    });
    // eslint-disable-next-line
  }, [displayedNutrient, intake_history]);

  const getPreviousDate = (pastDay) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - pastDay);
    const dd = String(currentDate.getDate()).padStart(2, "0");
    const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
    const yyyy = currentDate.getFullYear();
    return mm + "/" + dd + "/" + yyyy;
  };

  // Gets past 7 days dates (counting from todays date)
  const displayedDates = [
    getPreviousDate(6),
    getPreviousDate(5),
    getPreviousDate(4),
    getPreviousDate(3),
    getPreviousDate(2),
    getPreviousDate(1),
    getPreviousDate(0),
  ];

  // If two dates from two seperate arrays match it returns their value at a specific index of the array based on the dates that were matched (if the date is monday then the item goes in array[0], if the date is tuesday then the items goes in array[1], etc...) and if it doesnt match that index gets a value of 0.
  const getMatchingDatesData = (nutrient) => {
    let matchedDatesData;
    let displayedValues;
    if (intake_history.length !== 0) {
      matchedDatesData = displayedDates.map((item) =>
        intake_history.filter((item2) => (item === item2.date ? item2.calories : 0))
      );
    }
    if (matchedDatesData !== undefined) {
      displayedValues = matchedDatesData.map((item) => {
        if (item.length > 0 && item[0] !== "") {
          if (item.length > 1) {
            return item.reduce((allItems, item) => JSON.parse(allItems) + JSON.parse(item[nutrient]), 0);
          } else {
            return JSON.parse(item[0][nutrient]);
          }
        } else {
          return 0;
        }
      });
    }
    if (displayedValues !== undefined) {
      return displayedValues;
    }
  };

  // Returns nutrient data set
  const getNutrientDataSet = (label, weeklyNutrient) => {
    return [
      {
        label: `${label}(g)`,
        data: weeklyNutrient !== undefined ? [...weeklyNutrient] : [],
        backgroundColor: "rgba(253, 143, 64, 0.9)",
      },
    ];
  };

  return <Bar data={data !== undefined ? data : {}} options={options} />;
};

export default Chart;
